import React, {useCallback, useEffect, useState} from 'react';
import FinanceRentPanel from './FinanceRentPanel';
import FinanceMonthTabs from './FinanceMonthTabs';
import '../../styles/scss/finance.scss';
const endpoint = `${process.env.REACT_APP_API_URL || ''}/api/finance/rents/`;

export default function RentManagementPage(){
  const [month,setMonth]=useState(()=>new Date().toLocaleDateString('sv-SE',{timeZone:'Asia/Tokyo'}).slice(0,7));
  const [data,setData]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),[notice,setNotice]=useState('');
  const load=useCallback(async(signal)=>{
    const response=await fetch(`${endpoint}?month=${month}`,{credentials:'include',signal});
    const body=await response.json();
    if(!response.ok)throw new Error(body.error||'家賃データを取得できませんでした。');
    setData(body);
  },[month]);
  useEffect(()=>{
    const controller=new AbortController();
    setData(null);setError('');setNotice('');
    load(controller.signal).catch(e=>{if(e.name!=='AbortError')setError(e.message);});
    return ()=>controller.abort();
  },[load]);
  async function save(payload,after){
    setBusy(true);setError('');setNotice('');
    try{
      const response=await fetch(endpoint,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json','X-CSRFToken':data.csrf_token},body:JSON.stringify(payload)});
      const body=await response.json();
      if(!response.ok)throw new Error(body.error||'保存できませんでした。');
      if(after)after();
      await load();setNotice('保存しました。店舗収支にも反映されます。');
    }catch(e){setError(e.message);}finally{setBusy(false);}
  }
  return <div className="finance-page"><header><h1>家賃・スタジオ代の管理</h1><p>月ごとの支払先・金額・校舎を登録します。</p></header>
    <FinanceMonthTabs label="対象月" statuses={data?.month_statuses||{}} statusScope="家賃の入力" value={month} onChange={setMonth} disabled={busy}/>
    {error&&<p role="alert" className="finance-alert">{error}</p>}
    {notice&&<p role="status" className="finance-note">{notice}</p>}
    {!data&&!error&&<p>読み込み中…</p>}
    {data&&<FinanceRentPanel month={month} rows={data.rows} studios={data.studios} save={save} busy={busy}/>}
  </div>;
}
